import { RequestAffiliateProgramStatus } from "../utils";
import axiosClient from "../../../../system/helpers/axiosConfig";

export const postProgramStatus = (params: RequestAffiliateProgramStatus) => {
  return axiosClient
    .post(`api/admin/programs/status`, params)
    .then((r) => r.data.data);
};
